import { AlgAttivazioniStopModalComponent } from "./../dialogs/alg-attivazioni-stop-modal/alg-attivazioni-stop-modal.component";
import { Attivazione } from "./../../../models/attivazione";
import { ModalDialogService } from "ngx-modal-dialog";
import { AlgAttivazioniService } from "./../../../services/alg-attivazioni.service";
import {
  Component,
  OnInit,
  ViewContainerRef,
  HostListener
} from "@angular/core";
import { UtilsService } from "../../../services/utils.service";
import { takeUntil } from "rxjs/operators";
import { StopOnboardingModalComponent } from "../../dialogs/stop-onboarding-modal/stop-onboarding-modal.component";

@Component({
  selector: "alg-attivazioni-status-bar",
  templateUrl: "./alg-attivazioni-status-bar.component.html",
  styleUrls: ["./alg-attivazioni-status-bar.component.scss"]
})
export class AlgAttivazioniStatusBarComponent implements OnInit {
  public attivazione = {} as Attivazione;
  public isSaveAvailable = false;
  progresses = {
    init: 0,
    step1: 0,
    step2: 30,
    step3: 90,
    step4: 90,
    complete: 100,
    sent: 100
  };
  public steps = {
    init: {
      num: "1/3",
      name: "Tipologia di immobile"
    },
    step1: {
      num: "1/3",
      name: "Tipologia di immobile"
    },
    step2: {
      num: "2/3",
      name: "I tuoi documenti"
    },
    step3: {
      num: "3/3",
      name: "Riepilogo"
    },
    step4: {
      num: "3/3",
      name: "Riepilogo"
    }
  };
  public progress = 0;
  public currentStepNum = "";
  public currentStep = "";

  constructor(
    private api: AlgAttivazioniService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.api.attivazione$.subscribe(attivazione => {
      this.attivazione = attivazione;
      this.progress = this.progresses[attivazione.webStatus];
      this.currentStep = this.steps[attivazione.webStatus].name;
      this.currentStepNum = this.steps[attivazione.webStatus].num;
      this.isSaveAvailable =
        this.attivazione.email && this.attivazione.email.length > 0 && true;
    });
  }

  openModal() {
    this.utils.disableOverflow();
    if (this.isSaveAvailable) {
      const data = { ...this.attivazione };
      data.sendEmail = true;
      this.api.saveAndStoreAttivazione(data, true);
      this.modalDialogService.openDialog(this.viewContainer, {
        title: "Salva e Sospendi",
        childComponent: AlgAttivazioniStopModalComponent,
        settings: {
          closeButtonClass: "close theme-icon-close"
        },
        data: {
          text: ""
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-status-bar/alg-attivazioni-status-bar.component.ts